import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'; 
import App from './App';
import './index.css';

// Replace ReactDOM.render with createRoot
const root = ReactDOM.createRoot(document.getElementById('root'));

// Wrap your app inside a Router
root.render(
  <React.StrictMode>
  <Router>
    <Routes>
      <Route path="/*" element={<App />} />
    </Routes>
  </Router>
  </React.StrictMode>
);